export const ReferralEmptyState = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <g clipPath="url(#clip0_357_6063)">
      <path
        d="M10.0833 10.0833C10.0833 8.56717 8.84944 7.33333 7.33327 7.33333H2.74994C1.23377 7.33333 -5.98957e-05 8.56717 -5.98957e-05 10.0833V11.9167H10.0833V10.0833ZM5.04161 6.41667C6.81077 6.41667 8.24994 4.9775 8.24994 3.20833C8.24994 1.43917 6.81077 0 5.04161 0C3.27244 0 1.83327 1.43917 1.83327 3.20833C1.83327 4.9775 3.27244 6.41667 5.04161 6.41667ZM21.9999 19.25V22H10.0833V19.25C10.0833 17.7338 11.3171 16.5 12.8333 16.5H19.2499C20.7661 16.5 21.9999 17.7338 21.9999 19.25ZM16.0416 15.5833C18.3159 15.5833 20.1666 13.7326 20.1666 11.4583C20.1666 9.18408 18.3159 7.33333 16.0416 7.33333C13.7674 7.33333 11.9166 9.18408 11.9166 11.4583C11.9166 13.7326 13.7674 15.5833 16.0416 15.5833ZM7.71736 17.0445C8.42686 17.7549 8.42686 18.9118 7.71736 19.6222L5.41927 21.9202L4.12311 20.6241L5.49627 19.2509H2.74902C1.23286 19.2509 -0.000976562 18.0171 -0.000976562 16.5009V13.7509H1.83236V16.5009C1.83236 17.0069 2.24394 17.4176 2.74902 17.4176H5.50452L4.12219 16.0444L5.41836 14.7483L7.71552 17.0454L7.71736 17.0445Z"
        fill="#B8B5C2"
      />
    </g>
    <defs>
      <clipPath id="clip0_357_6063">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
